
import { create } from 'zustand';

export const useDocumentTypeStore = create((set) => ({
  // Data
  documentTypes: [],
  loading: false,
  error: null,
  success: null,

  // Pagination
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  // Search & Filter
  searchParams: {
    searchTerm: '',
    sortBy: 'createdAt',
    sortDirection: 'desc'
  },
  columnFilters: {},
  uniqueValues: {},

  // UI State
  isFormOpen: false,
  isEditMode: false,
  deleteDialogOpen: false,
  selectedDocumentType: null,
  documentTypeToDelete: null,


  // Actions - Data
  setDocumentTypes: (documentTypes) => set({ documentTypes }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setSuccess: (success) => set({ success }),
  setPaginationData: (paginationData) => set({ paginationData }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  // Actions - Search & Filter
  setSearchParams: (params) => set((state) => ({
    searchParams: { ...state.searchParams, ...params }
  })),
  setColumnFilters: (filters) => set({ columnFilters: filters }),

  // Actions - UI
  openAddForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedDocumentType: null,
    error: null,
    success: null
  }),

  openEditForm: (documentType) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedDocumentType: documentType,
    error: null,
    success: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    selectedDocumentType: null,
    error: null,
    success: null
  }),

  openDeleteDialog: (documentType) => set({
    deleteDialogOpen: true,
    documentTypeToDelete: documentType
  }),

  closeDeleteDialog: () => set({
    deleteDialogOpen: false,
    documentTypeToDelete: null
  }),



  clearError: () => set({ error: null }),
  clearSuccess: () => set({ success: null }),
}));
